<template>
  <div>
    <el-row style="margin-top: 20px; padding-left: 5px">
      <el-col :sm="24">
        <div style="display: inline-block; margin-right: 10px">
          <strong style="font-size: 13px">{{ $t('select.shop') }}</strong><br>
          <el-select size="small" :placeholder="$t('select.shop')" v-model="shopee_shop.selected" filterable>
            <el-option-group :label="$t('shop.added')">
              <el-option v-for="item in shopee_shop.list.filter(i => !i.is_sub_account)" :key="item.username"
                         :label="`${item.username} ${item.name}`" :value="item._id">
                <div>
                  <table style="width:100%;">
                    <tbody>
                    <tr>
                      <td style="width:40px;">
                        <img style="width:28px; height:28px; border-radius: 50vh;"
                             :src="logo_channel(item.channel)"
                             alt="image">
                      </td>
                      <td style="padding-left:10px;">
                        {{ item.username }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </el-option>
            </el-option-group>
            <el-option-group :label="$t('shop.managed')">
              <el-option v-for="item in shopee_shop.list.filter(i => i.is_sub_account)" :key="item.username"
                         :label="`${item.username} ${item.name}`" :value="item._id">
                <div>
                  <table style="width:100%;">
                    <tbody>
                    <tr>
                      <td style="width:40px;">
                        <img style="width:28px; height:28px; border-radius: 50vh;"
                             :src="logo_channel(item.channel)"
                             alt="image">
                      </td>
                      <td style="padding-left:10px;">
                        {{ item.username }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div style="display: inline-block; margin-right: 10px">
          <span style="font-weight: 700">Chọn thời gian tham chiếu</span> <br>
          <el-date-picker
            v-model="date"
            :type="'month'"
            :format="'MM-yyyy'"
            :placeholder="$t('input.select_time')"
            class="full-w"
            size="small"
            :clearable="false"
            @change="m__on_change_date">
          </el-date-picker>
        </div>
        <div style="display: inline-block; margin-right: 10px">
          <span style="font-weight: 700">Chọn file kế hoạch tham chiếu</span> <br>
          <el-select size="small" v-model="selected_file" :disabled="!shopee_shop.selected ||loading.generate_data"
                     filterable @change="m__generate_expected">
            <el-option v-for="item in c__show_agency_file_filter_list" :key="item.id"
                       :value="item.id" :label="item.filename"></el-option>
          </el-select>
        </div>
        <div style="display: inline-block; margin-right: 10px">
          <span style="font-weight: 700">Loại đơn hàng</span> <br>
          <el-select value="" size="small" :disabled="!shopee_shop.selected" v-model="order_type">
            <el-option :value="''" label="Tất Cả Đơn"></el-option>
            <el-option :value="'confirmed'" :label="$t('center.confirmed_order')"></el-option>
            <el-option :value="'paid'" :label="$t('center.paid_order')"></el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>

    <el-row style="margin-top: 30px; padding-left: 5px">
      <div id="double-scroll-wrapper-result" style="position: fixed; z-index: 2000; bottom: 0;">
        <div id="double-scroll-bar-result">
        </div>
      </div>

      <el-row>
        <el-col :sm="24">
          <strong style="font-size: 14px" class="text-primary">
            Doanh thu kỳ vọng: {{ m__get_target_gmv() | format_currency }}</strong>&nbsp;&nbsp;&nbsp;&nbsp;
          <strong style="font-size: 14px" class="text-success">
            Doanh thu thực tế: {{ m__get_res_gmv() | format_currency }}</strong>&nbsp;&nbsp;&nbsp;&nbsp;
          <strong style="font-size: 14px" class="text-danger">
            Tỉ lệ hoàn thành: {{ m__get_complete_percent() }} %</strong>&nbsp;&nbsp;&nbsp;&nbsp;
          <strong style="font-size: 14px" class="text-warning">
            Tỉ lệ hoàn thành tới ngày hôm nay: {{ m__get_percent_until_now() }} %</strong>
        </el-col>
      </el-row>

      <el-row style="margin-top: 20px">
        <el-col :sm="24" class="text-right">
          <el-button type="info" size="mini" icon="el-icon-download" @click="export_file_excel">Tải file Excel
          </el-button>
          <!--          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.generate_data"-->
          <!--                     @click="m__generate_expected">-->
          <!--            Tạo dữ liệu chi tiết-->
          <!--          </el-button>-->
        </el-col>
      </el-row>

      <el-table id="main-table-result-fixed" :data="[]"
                :cell-class-name="m__cell_style" :header-cell-class-name="m__header_style">
        <el-table-column fixed label="#" prop="index" width="40px"></el-table-column>
        <el-table-column fixed label="Ngày" prop="time" width="100px"></el-table-column>
        <el-table-column label="Shopee Event" prop="event" width="100px" show-tooltip-when-overflow></el-table-column>
        <el-table-column label="Kế hoạch" align="center">
          <el-table-column label="Chỉ số toàn shop" align="center">
            <el-table-column label="Target GMV" width="140px" prop="target_gmv">
              <template slot-scope="scope">
                <strong v-if="scope.row.is_first" class="text-warning">Còn: {{
                    scope.row.target_gmv | format_currency
                  }}</strong>
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_gmv" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="AOV" width="140px">
              <template slot-scope="scope">
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_aov" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="Order" width="140px">
              <template slot-scope="scope">
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_order" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="Traffic" width="140px">
              <template slot-scope="scope">
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_traffic" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="CR %" width="140px">
              <template slot-scope="scope">
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_cr" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$t('base.ads_metrics')" align="center">
            <el-table-column label="Target GMV Ads" width="140px" prop="target_gmv_ads">
              <template slot-scope="scope">
                <strong v-if="scope.row.is_first" class="text-warning">Còn: {{
                    scope.row.target_gmv_ads | format_currency
                  }}</strong>
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_gmv_ads" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.ads_expense')" width="140px">
              <template slot-scope="scope">
                <strong v-if="scope.row.is_first" class="text-danger">Còn: {{
                    scope.row.target_cost | format_currency
                  }}</strong>
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_cost" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="Target AOV Ads" width="140px" prop="target_aov_ads">
              <template slot-scope="scope">
                <strong v-if="scope.row.is_first" class="text-warning">Còn: {{
                    scope.row.target_aov_ads | format_currency
                  }}</strong>
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_aov_ads" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="Order Ads" width="140px" prop="target_order_ads">
              <template slot-scope="scope">
                <strong v-if="scope.row.is_first" class="text-warning">Còn: {{
                    scope.row.target_order_ads | format_currency
                  }}</strong>
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_order_ads" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="View Ads" width="140px" prop="target_view_ads">
              <template slot-scope="scope">
                <strong v-if="scope.row.is_first" class="text-warning">Còn: {{
                    scope.row.target_view_ads | format_currency
                  }}</strong>
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_view_ads" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="Click Ads" width="140px" prop="target_click_ads">
              <template slot-scope="scope">
                <strong v-if="scope.row.is_first" class="text-warning">Còn: {{
                    scope.row.target_click_ads | format_currency
                  }}</strong>
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_click_ads" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="CTR" width="140px" prop="target_ctr">
              <template slot-scope="scope">
                <strong v-if="scope.row.is_first" class="text-warning">Còn: {{
                    scope.row.target_ctr | format_currency
                  }}</strong>
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_ctr" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="CR Ads %" width="140px" prop="target_cr_ads">
              <template slot-scope="scope">
                <strong v-if="scope.row.is_first" class="text-warning">Còn: {{
                    scope.row.target_cr_ads | format_currency
                  }}</strong>
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_cr_ads" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table-column>
        <el-table-column label="Thực tế" align="center" prop="res_gmv">
          <el-table-column label="Chỉ số toàn shop" align="center">
            <el-table-column label="GMV" prop="res_gmv" width="120px">
              <template slot-scope="scope">{{ scope.row.res_gmv | format_currency }}</template>
            </el-table-column>
            <el-table-column label="Order" prop="res_order" width="90px">
              <template slot-scope="scope">{{ scope.row.res_order | format_currency }}</template>
            </el-table-column>
            <el-table-column label="AOV" prop="res_aov" width="90px">
              <template slot-scope="scope">{{ scope.row.res_aov | format_currency }}</template>
            </el-table-column>
            <el-table-column label="Traffic" prop="res_traffic" width="90px"></el-table-column>
            <el-table-column label="CR %" prop="res_cr" width="90px"></el-table-column>
          </el-table-column>
          <el-table-column :label="$t('base.ads_metrics')" align="center">
            <el-table-column label="GMV Ads" prop="res_gmv_ads" width="120px">
              <template slot-scope="scope">{{ scope.row.res_gmv_ads | format_currency }}</template>
            </el-table-column>
            <el-table-column :label="$t('metric.ads_expense')" prop="res_gmv_ads" width="120px">
              <template slot-scope="scope">{{ scope.row.res_cost | format_currency }}</template>
            </el-table-column>
            <el-table-column label="AOV Ads" prop="res_aov_ads" width="90px">
              <template slot-scope="scope">{{ scope.row.res_aov_ads | format_currency }}</template>
            </el-table-column>
            <el-table-column label="Order Ads" prop="res_order_ads" width="90px">
              <template slot-scope="scope">{{ scope.row.res_order_ads | format_currency }}</template>
            </el-table-column>
            <el-table-column label="View Ads" prop="res_view_ads" width="90px">
              <template slot-scope="scope">{{ scope.row.res_view_ads | format_currency }}</template>
            </el-table-column>
            <el-table-column label="Click Ads" prop="res_view_ads" width="90px">
              <template slot-scope="scope">{{ scope.row.res_click_ads | format_currency }}</template>
            </el-table-column>
            <el-table-column label="CTR" prop="res_ctr" width="90px">
              <template slot-scope="scope">{{ scope.row.res_ctr }}</template>
            </el-table-column>
            <el-table-column label="CR Ads %" prop="res_cr_ads" width="90px">
              <template slot-scope="scope">{{ scope.row.res_cr_ads }}</template>
            </el-table-column>
          </el-table-column>
          <!--          <el-table-column label="Hoàn thành" prop="res_complete" width="90px">
                      <template slot-scope="scope">
                        {{ scope.row.target_gmv !== 0 ? (+scope.row.res_gmv * 100 / +scope.row.target_gmv).toFixed(2) : 0 }} %
                      </template>
                    </el-table-column>-->
        </el-table-column>
      </el-table>

      <el-table id="main-table-result" :data="data" style="margin-top: 10px" v-loading="loading.generate_data"
                :cell-class-name="m__cell_style" :header-cell-class-name="m__header_style" class="plan-table">
        <el-table-column fixed label="#" prop="index" width="40px"></el-table-column>
        <el-table-column fixed label="Ngày" prop="time" width="100px"></el-table-column>
        <el-table-column label="Shopee Event" prop="event" width="100px" show-tooltip-when-overflow></el-table-column>
        <el-table-column label="Kế hoạch" align="center">
          <el-table-column label="Chỉ số toàn shop" align="center">
            <el-table-column label="Target GMV" width="140px" prop="target_gmv">
              <template slot-scope="scope">
                <strong v-if="scope.row.is_first" class="text-warning">Còn: {{
                    scope.row.target_gmv | format_currency
                  }}</strong>
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_gmv" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="AOV" width="140px">
              <template slot-scope="scope">
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_aov" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="Order" width="140px">
              <template slot-scope="scope">
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_order" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="Traffic" width="140px">
              <template slot-scope="scope">
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_traffic" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="CR %" width="140px">
              <template slot-scope="scope">
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_cr" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$t('base.ads_metrics')" align="center">
            <el-table-column label="Target GMV Ads" width="140px" prop="target_gmv_ads">
              <template slot-scope="scope">
                <strong v-if="scope.row.is_first" class="text-warning">Còn: {{
                    scope.row.target_gmv_ads | format_currency
                  }}</strong>
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_gmv_ads" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.ads_expense')" width="140px">
              <template slot-scope="scope">
                <strong v-if="scope.row.is_first" class="text-danger">Còn: {{
                    scope.row.target_cost | format_currency
                  }}</strong>
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_cost" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="Target AOV Ads" width="140px" prop="target_aov_ads">
              <template slot-scope="scope">
                <strong v-if="scope.row.is_first" class="text-warning">Còn: {{
                    scope.row.target_aov_ads | format_currency
                  }}</strong>
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_aov_ads" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="Order Ads" width="140px" prop="target_order_ads">
              <template slot-scope="scope">
                <strong v-if="scope.row.is_first" class="text-warning">Còn: {{
                    scope.row.target_order_ads | format_currency
                  }}</strong>
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_order_ads" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="View Ads" width="140px" prop="target_view_ads">
              <template slot-scope="scope">
                <strong v-if="scope.row.is_first" class="text-warning">Còn: {{
                    scope.row.target_view_ads | format_currency
                  }}</strong>
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_view_ads" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="Click Ads" width="140px" prop="target_click_ads">
              <template slot-scope="scope">
                <strong v-if="scope.row.is_first" class="text-warning">Còn: {{
                    scope.row.target_click_ads | format_currency
                  }}</strong>
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_click_ads" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="CTR" width="140px" prop="target_ctr">
              <template slot-scope="scope">
                <strong v-if="scope.row.is_first" class="text-warning">Còn: {{
                    scope.row.target_ctr | format_currency
                  }}</strong>
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_ctr" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="CR Ads %" width="140px" prop="target_cr_ads">
              <template slot-scope="scope">
                <strong v-if="scope.row.is_first" class="text-warning">Còn: {{
                    scope.row.target_cr_ads | format_currency
                  }}</strong>
                <el-input v-if="!scope.row.is_first" type="number" size="mini" class="invisible-input"
                          v-model="scope.row.target_cr_ads" :disabled="!scope.row.editable"></el-input>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table-column>
        <el-table-column label="Thực tế" align="center" prop="res_gmv">
          <el-table-column label="Chỉ số toàn shop" align="center">
            <el-table-column label="GMV" prop="res_gmv" width="120px">
              <template slot-scope="scope">
                {{ scope.row.res_gmv | format_currency }}
                <div>
                  <strong
                    :class=" m__get_process_percent(scope.row, 'gmv') >= 100 ? 'text-success' : 'text-danger'">
                    {{ m__get_process_percent(scope.row, 'gmv') }}%
                  </strong>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="AOV" prop="res_aov" width="90px">
              <template slot-scope="scope">
                {{ scope.row.aov | format_currency }}
                <div>
                  <strong
                    :class=" m__get_process_percent(scope.row, 'aov') >= 100 ? 'text-success' : 'text-danger'">
                    {{ m__get_process_percent(scope.row, 'aov') }}%
                  </strong>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Order" prop="res_order" width="90px">
              <template slot-scope="scope">
                {{ scope.row.res_order | format_currency }}
                <div>
                  <strong
                    :class=" m__get_process_percent(scope.row, 'order') >= 100 ? 'text-success' : 'text-danger'">
                    {{ m__get_process_percent(scope.row, 'order') }}%
                  </strong>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Traffic" prop="res_traffic" width="90px">
              <template slot-scope="scope">
                {{ scope.row.res_traffic | format_currency }}
                <div>
                  <strong
                    :class=" m__get_process_percent(scope.row, 'traffic') >= 100 ? 'text-success' : 'text-danger'">
                    {{ m__get_process_percent(scope.row, 'traffic') }}%
                  </strong>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="CR %" prop="res_cr" width="90px">
              <template slot-scope="scope">
                {{ scope.row.res_cr | format_currency }}
                <div>
                  <strong
                    :class=" m__get_process_percent(scope.row, 'cr') >= 100 ? 'text-success' : 'text-danger'">
                    {{ m__get_process_percent(scope.row, 'cr') }}%
                  </strong>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$t('base.ads_metrics')" align="center">
            <el-table-column label="GMV Ads" prop="res_gmv_ads" width="120px">
              <template slot-scope="scope">
                {{ scope.row.res_gmv_ads | format_currency }}
                <div>
                  <strong
                    :class=" m__get_process_percent(scope.row, 'gmv_ads') >= 100 ? 'text-success' : 'text-danger'">
                    {{ m__get_process_percent(scope.row, 'gmv_ads') }}%
                  </strong>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.ads_expense')" prop="res_cost" width="120px">
              <template slot-scope="scope">
                {{ scope.row.res_cost | format_currency }}
                <div>
                  <strong
                    :class=" m__get_process_percent(scope.row, 'cost') >= 100 ? 'text-success' : 'text-danger'">
                    {{ m__get_process_percent(scope.row, 'cost') }}%
                  </strong>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="AOV Ads" prop="res_aov_ads" width="90px">
              <template slot-scope="scope">
                {{ scope.row.res_aov_ads | format_currency }}
                <div>
                  <strong
                    :class=" m__get_process_percent(scope.row, 'aov_ads') >= 100 ? 'text-success' : 'text-danger'">
                    {{ m__get_process_percent(scope.row, 'aov_ads') }}%
                  </strong>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Order Ads" prop="res_order_ads" width="90px">
              <template slot-scope="scope">
                {{ scope.row.res_order_ads | format_currency }}
                <div>
                  <strong
                    :class=" m__get_process_percent(scope.row, 'order_ads') >= 100 ? 'text-success' : 'text-danger'">
                    {{ m__get_process_percent(scope.row, 'order_ads') }}%
                  </strong>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="View Ads" prop="res_view_ads" width="90px">
              <template slot-scope="scope">
                {{ scope.row.res_view_ads | format_currency }}
                <div>
                  <strong
                    :class=" m__get_process_percent(scope.row, 'view_ads') >= 100 ? 'text-success' : 'text-danger'">
                    {{ m__get_process_percent(scope.row, 'view_ads') }}%
                  </strong>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Click Ads" prop="res_click_ads" width="90px">
              <template slot-scope="scope">
                {{ scope.row.res_click_ads | format_currency }}
                <div>
                  <strong
                    :class=" m__get_process_percent(scope.row, 'click_ads') >= 100 ? 'text-success' : 'text-danger'">
                    {{ m__get_process_percent(scope.row, 'click_ads') }}%
                  </strong>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="CTR" prop="res_ctr" width="90px">
              <template slot-scope="scope">
                {{ scope.row.res_ctr || 0 }}
                <div>
                  <strong
                    :class=" m__get_process_percent(scope.row, 'ctr') >= 100 ? 'text-success' : 'text-danger'">
                    {{ m__get_process_percent(scope.row, 'ctr') }}%
                  </strong>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="CR Ads %" prop="res_cr_ads" width="90px">
              <template slot-scope="scope">
                {{ scope.row.res_cr_ads || 0 }}
                <div>
                  <strong
                    :class=" m__get_process_percent(scope.row, 'cr_ads') >= 100 ? 'text-success' : 'text-danger'">
                    {{ m__get_process_percent(scope.row, 'cr_ads') }}%
                  </strong>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <!--          <el-table-column label="Hoàn thành" prop="res_complete" width="90px">
                      <template slot-scope="scope">
                        {{ scope.row.target_gmv !== 0 ? (+scope.row.res_gmv * 100 / +scope.row.target_gmv).toFixed(2) : 0 }} %
                      </template>
                    </el-table-column>-->
        </el-table-column>
      </el-table>
      <div id="main-pagination-result"></div>
    </el-row>
  </div>
</template>

<script>
import {orderBy as _orderBy} from 'lodash'
import {get_shop_mixins} from '../../mixins/get_shop';

export default {
  name: 'page__agency_result',

  mixins: [get_shop_mixins],

  props: {
    counter: 0
  },

  data() {
    return {
      seller: null,
      years: [],
      year: null,
      months: [],
      month: null,
      date: new Date(),
      order_type: 'confirmed',

      agency_files: [],
      selected_file: '',

      data: [],
      file_data: [],

      loading: {generate_data: false},
      show_dialog: {},
      interval: null,

      send_request_list: []
    }
  },

  async beforeMount() {
    this.years = []
    for (let i = this.dayjs().year(); i >= this.dayjs().year() - 2; i--) {
      this.years.push(i)
    }

    // this.months = []
    // const end_month = this.year >= this.dayjs().year() ? this.dayjs().month() + 1 : 12
    // for (let i = 0; i < end_month; i++) {
    //   this.months.push(i)
    // }
    // this.month = this.dayjs().month()
    this.year = this.dayjs().year()
    this.month = this.dayjs().month()

    await this.m__get_shopee_shop()
    await this.m__send_request_list()
    await this.m__get_agency_file()

    await this.m__change_shop()
  },

  beforeDestroy() {
    clearInterval(this.interval)
    const dashboard_wrapper = document.getElementById('dashboard-wrapper')
    dashboard_wrapper.onscroll = () => {
    }
  },

  watch: {
    'shopee_shop.selected': function () {
      this.m__initial_view()
    },

    'counter': function () {
      this.m__get_agency_file()
    }
  },

  computed: {
    c__show_agency_file_filter_list() {
      return this.agency_files.filter(i => i.shopId === this.shopee_shop.selected)
    }
  },

  methods: {
    m__get_process_percent(data, key) {
      // if (!data || !data[`res_${key}`]) return 0

      return this.is_percent_of(data[`res_${key}`], data[`target_${key}`], 2)
    },

    m__on_change_date() {
      this.month = this.dayjs(this.date).month()
      this.year = this.dayjs(this.date).year()
    },

    async m__send_request_list() {
      const resp = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/sub_account/send_request_list', this.cf())
      this.send_request_list = resp.body.data
    },

    async export_file_excel() {
      if (!this.data || !this.data.length) {
        return
      }

      const data = [
        ['Ngày', 'Event Shopee', 'Kế hoạch', '', '', '', '', '', '', 'Thực tế'],
        ['', '', 'Target GMV', 'Target GMV Ads', 'Chi phí Ads', 'AOV', 'Order', 'Traffic', 'CR',
          'GMV', 'GMV Ads', 'Chi phí Ads', 'Order', 'Order Ads', 'AOV', 'Traffic', 'Traffic Ads', 'CR', 'Hoàn thành'],
        [''],
        ['']
      ]

      for (const item of this.data) {
        const row = [item.time, item.event, item.target_gmv, item.target_gmv_ads, item.target_cost, item.target_aov, item.target_order,
          item.target_traffic, item.target_cr, item.res_gmv, item.res_gmv_ads, item.res_cost, item.res_order, item.res_order_ads,
          item.res_aov, item.res_traffic, item.res_traffic_ads, item.res_cr, item.target_gmv !== 0 ? (+item.res_gmv * 100 / +item.target_gmv).toFixed(2) : 0]
        data.push(row)
      }

      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
        data: data,
        filename: `file-ket-qua-thuc-hien-${this.month + 1}-${this.year}.xlsx`
      }, {
        ...this.cf(),
        responseType: 'blob'
      })

      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `file-ket-qua-thuc-hien-${this.month + 1}-${this.year}.xlsx`)
      document.body.appendChild(link)
      link.click()
    },

    async m__change_shop() {
      if (this.$route.query.file) this.selected_file = this.$route.query.file
      if (this.$route.query.month) this.month = this.$route.query.month
      if (this.$route.query.shop) this.shopee_shop.selected = this.$route.query.shop
    },

    m__generate_scrollbar() {
      this.$nextTick(() => {
        try {
          const dashboard_wrapper = document.getElementById('dashboard-wrapper')
          const main_pagination = document.getElementById('main-pagination-result')

          const main_table = document.querySelector('div#main-table-result')
          const main_table_fixed = document.querySelector('div#main-table-result-fixed')
          const main_table_wrapper = document.querySelector('div#main-table-result div.el-table__body-wrapper')
          const main_table_wrapper_fixed = document.querySelector('div#main-table-result-fixed div.el-table__header-wrapper')
          const scrollbar = document.getElementById('double-scroll-bar-result')

          const scrollbar_wrapper = document.getElementById('double-scroll-wrapper-result')
          scrollbar_wrapper.style.width = main_table.scrollWidth + 'px'
          main_table_fixed.style.width = main_table.scrollWidth + 'px'

          scrollbar.appendChild(document.createElement('div'))
          scrollbar.style.overflow = 'auto'
          scrollbar.style.overflowY = 'hidden'
          scrollbar.firstChild.style.width = main_table_wrapper.scrollWidth + 'px'
          this.interval = setInterval(() => {
            scrollbar_wrapper.style.width = main_table.scrollWidth + 'px'
            main_table_fixed.style.width = main_table.scrollWidth + 'px'
            scrollbar.firstChild.style.width = main_table_wrapper.scrollWidth + 'px'
          }, 1000)
          scrollbar.firstChild.style.paddingTop = '1px'
          scrollbar.firstChild.appendChild(document.createTextNode('\xA0'))
          scrollbar.onscroll = () => {
            main_table_wrapper.scrollLeft = scrollbar.scrollLeft
            main_table_wrapper_fixed.scrollLeft = main_table_wrapper.scrollLeft
          }
          main_table_wrapper.onscroll = () => {
            scrollbar.scrollLeft = main_table_wrapper.scrollLeft
            main_table_wrapper_fixed.scrollLeft = main_table_wrapper.scrollLeft
          }

          const bounding_main_pagination = () => {
            const rect = main_pagination.getBoundingClientRect()
            const elem_top = rect.top
            const is_visible = elem_top <= window.innerHeight
            if (is_visible) {
              scrollbar_wrapper.style.zIndex = '-1'
            } else {
              scrollbar_wrapper.style.zIndex = '2000'
            }

            const rect2 = main_table_wrapper.getBoundingClientRect()
            const elem_top2 = rect2.top
            if (elem_top2 > 0) {
              main_table_fixed.style.zIndex = '-1'
            } else {
              main_table_fixed.style.zIndex = '2000'
            }
          }
          bounding_main_pagination()

          dashboard_wrapper.onscroll = () => {
            bounding_main_pagination()
          }
        } catch (e) {
        }
      })
    },

    m__header_style({column}) {
      if (['Kế hoạch', 'GMV', 'Target GMV', 'Thực tế', 'Chỉ số toàn shop'].includes(column.label)) {
        return 'cell-style'
      }
    },

    m__cell_style({column}) {
      if (['target_gmv', 'res_gmv'].includes(column.property)) {
        return 'cell-style'
      } else {
        return ''
      }
    },

    m__get_target_gmv() {
      return this.data.reduce((total, item) => total + +item.target_gmv, 0)
    },

    m__get_res_gmv() {
      return this.data.reduce((total, item) => total + +item.res_gmv, 0)
    },

    m__get_complete_percent() {
      return this.m__get_target_gmv() !== 0 ? +(this.m__get_res_gmv() * 100 / this.m__get_target_gmv()).toFixed(2) : 0
    },

    m__get_percent_until_now() {
      let total_target_gmv = 0, total_res_gmv = 0
      for (const item of this.data) {
        const part = item.time.split('-')
        const time = this.dayjs().date(Number(part[0])).month(Number(part[1]) - 1).year(Number(part[2]))
        if (time.isAfter(this.dayjs(), 'd')) break

        total_target_gmv += Number(item.target_gmv)
        total_res_gmv += Number(item.res_gmv)
      }

      return total_target_gmv ? (total_res_gmv * 100 / total_target_gmv).toFixed(2) : 0
    },

    async m__get_agency_file() {
      // const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file/all', {
      // const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file', {
      const mipeeUserIds = [this.$store.state.userInfo.username, ...this.send_request_list.filter(i => i.status === 'accepted').map(i => i.request_user.username)].join(',')
      const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file/list', {
        ...this.cf(),
        params: {
          mipeeUserId: this.$store.state.userInfo.username,
          mipeeUserIds
        }
      })
      for (const item of resp.body) {
        item.loading = false
      }
      this.agency_files = resp.body.filter(i => this.$store.state.userInfo.username === 'vuducminhdev07' ? true : this.shopee_shop.list.some(ii => ii._id === i.shopId))

      this.selected_file = this.shopee_shop.selected === this.$route.query.shop && this.$route.query.file ? this.$route.query.file : ''

      if (this.agency_files.length && !this.selected_file) {
        const first = _orderBy(this.agency_files, ['year', 'month', 'createdAt'], ['desc', 'desc', 'desc'])[0]
        this.month = first.expectedMonth
        this.year = first.expectedYear
        this.date = this.dayjs([first.expectedYear, first.expectedMonth]).toDate()
        this.selected_file = first.id
        this.ntf_s('Đã sử dụng file kế hoạch: ' + first.filename)
      }
    },

    async m__initial_view() {
      let items = this.shopee_shop.list.filter(e => e._id === this.shopee_shop.selected)

      try {
        if (this.shopee_shop.selected.length > 6) {
          if (items.length > 0) {
            let item = items[0]
            this.shop = item
            this.seller = await this.init_seller(item)

            if (!await this.check_shop(this.seller)) {
              this.shopee_shop.selected = ''
              return
            }

            this.data = []

            await this.m__get_agency_file()
            this.ntf_s(`${this.$t('shop.connected_to')}: ${this.shop.username}`)

            if (this.selected_file) {
              await this.m__generate_expected()
            }
          }
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(`${this.$t('shop.connect_shop_error')}: ${this.shop.username}`)
      } finally {
      }
    },

    async m__generate_expected() {
      if (!this.shopee_shop.selected || this.month === null) {
        return
      }

      if (!this.selected_file) {
        this.ntf_w('Vui lòng chọn file kế hoạch')
        return
      }

      const file = this.agency_files.find(i => i.id === this.selected_file)
      if (!file) {
        this.ntf_w('Không tìm thấy file kế hoạch')
        return
      }

      // try {
      //   if (this.data.length) {
      //     await this.$confirm(`Bạn có muốn tạo lại dữ liệu không?`, this.$t('base.attention'), {
      //       type: 'warning',
      //       confirmButtonText: this.$t('base.confirm'),
      //       cancelButtonText: this.$t('base.cancel')
      //     })
      //   }
      // } catch (e) {
      //   return
      // }

      this.data_file = JSON.parse(file.data)

      this.loading.generate_data = true
      try {
        this.data = []
        const data = []

        let start_time = this.dayjs([this.year, this.month]).startOf('month')
        let end_time = this.dayjs([this.year, this.month]).endOf('month')
        let ene_time_request = end_time.isBefore(this.dayjs(), 'day')
          ? end_time
          : this.dayjs().endOf('day')

        const reports = []
        const resp = await this.seller.marketing_get_time_graph('new_cpc_homepage', start_time.unix(), ene_time_request.unix(), {})
        if (resp && resp.data && resp.data.report_by_time) {
          reports.push(...resp.data.report_by_time.map(i => {
            i.metrics.broad_gmv = Math.floor(i.metrics.broad_gmv / 100000)
            i.metrics.direct_gmv = Math.floor(i.metrics.broad_gmv / 100000)
            i.metrics.cost = Math.floor(i.metrics.broad_gmv / 100000)
            return {timestamp: +i.key, ...i.metrics}
          }))
        }

        const end_time_clone = end_time.isSameOrAfter(this.dayjs(), 'd') ? this.dayjs().startOf('d') : end_time.clone().add(1, 'd').startOf('d')
        const metrics_resp = await this.seller.dashboard__key_metrics(start_time.unix(), end_time_clone.unix(), 'month')
        const key_metrics = metrics_resp.result

        let i = 1
        while (start_time.isSameOrBefore(end_time, 'd')) {
          const row = {
            index: i++,
            time: start_time.format('DD/MM/YYYY'),
            event: start_time.date() === start_time.month() + 1 ? `Flash Sale ${start_time.date()}/${start_time.month() + 1}` : '',
            target_gmv: 0,
            target_cost: 0,
            target_aov: 0,
            target_order: 0,
            target_traffic: 0,
            target_traffic_ads: 0,
            target_cr: 0,
            target_aov_ads: 0,
            target_order_ads: 0,
            target_view_ads: 0,
            target_click_ads: 0,
            target_ctr: 0,
            target_cr_ads: 0,
            res_gmv: 0,
            res_gmv_ads: 0,
            res_cir: 0,
            res_aov: 0,
            res_order: 0,
            res_order_ads: 0,
            res_traffic: 0,
            res_traffic_ads: 0,
            res_cr: 0,
            res_complete: 0,
            editable: true
          }

          let place_gmv_key = 'place_gmv'
          if (this.order_type) place_gmv_key = place_gmv_key.replace(/(placed|place)/, this.order_type)
          const metrics = key_metrics[place_gmv_key].points
          const metrics_found = metrics.find(i => i.timestamp === start_time.unix())
          if (metrics_found && !start_time.isAfter(this.dayjs(), 'd')) {
            row.res_gmv = metrics_found.value
          }

          let place_orders_key = 'place_orders'
          if (this.order_type) place_orders_key = place_orders_key.replace(/(placed|place)/, this.order_type)
          const metrics2 = key_metrics[place_orders_key].points
          const metrics_found2 = metrics2.find(i => i.timestamp === start_time.unix())
          if (metrics_found2 && !start_time.isAfter(this.dayjs(), 'd')) {
            row.res_order = metrics_found2.value
          }

          let shop_uv_key = 'shop_uv'
          if (this.order_type) shop_uv_key = shop_uv_key.replace(/(placed|place)/, this.order_type)
          const metrics3 = key_metrics[shop_uv_key].points
          const metrics_found3 = metrics3.find(i => i.timestamp === start_time.unix())
          if (metrics_found3 && !start_time.isAfter(this.dayjs(), 'd')) {
            row.res_traffic = metrics_found3.value
          }

          let place_sales_per_order = 'place_sales_per_order'
          if (this.order_type) place_sales_per_order = place_sales_per_order.replace(/(placed|place)/, this.order_type)
          const metrics4 = key_metrics[place_sales_per_order].points
          const metrics_found4 = metrics4.find(i => i.timestamp === start_time.unix())
          if (metrics_found4 && !start_time.isAfter(this.dayjs(), 'd')) {
            row.res_aov = metrics_found4.value
          }
          row.res_cr = row.res_traffic > 0 ? +(row.res_order * 100 / row.res_traffic).toFixed(2) : 0.00

          const report_found_list = reports.filter(i => i.timestamp >= start_time.startOf('day').unix() && i.timestamp <= start_time.endOf('day').unix())
          row.res_gmv_ads = Math.floor(report_found_list.reduce((total, i) => total + i.broad_gmv, 0))
          row.res_cost = Math.floor(report_found_list.reduce((total, i) => total + i.cost, 0))
          row.res_order_ads = Math.floor(report_found_list.reduce((total, i) => total + i.broad_order, 0))
          row.res_traffic_ads = Math.floor(report_found_list.reduce((total, i) => total + i.click, 0))
          row.res_view_ads = Math.floor(report_found_list.reduce((total, i) => total + i.impression, 0))
          row.res_click_ads = Math.floor(report_found_list.reduce((total, i) => total + i.click, 0))
          row.res_aov_ads = +row.res_order_ads ? Math.floor(+row.res_gmv_ads / +row.res_order_ads) : 0
          row.res_ctr = +row.res_view_ads ? +(+row.res_click_ads / +row.res_view_ads * 100).toFixed(2) : 0
          row.res_cr_ads = +row.res_click_ads ? +(+row.res_order_ads / +row.res_click_ads * 100).toFixed(2) : 0
          row.res_cir = +row.res_gmv_ads ? +(+row.rest_cost / +row.res_gmv_ads * 100).toFixed(1) : 0

          const data_find = this.data_file.find(i => i.time === row.time)
          if (data_find) {
            row.event = data_find.event
            row.target_gmv = data_find.target_gmv
            row.target_gmv_ads = data_find.target_gmv_ads
            row.target_cost = data_find.target_cost
            row.target_aov = data_find.target_aov
            row.target_order = data_find.target_order
            row.target_traffic = data_find.target_traffic
            row.target_cr = data_find.target_cr
            row.target_aov_ads = data_find.target_aov_ads
            row.target_order_ads = data_find.target_order_ads
            row.target_view_ads = data_find.target_view_ads
            row.target_click_ads = data_find.target_click_ads
            row.target_ctr = data_find.target_ctr
            row.target_cr_ads = data_find.target_cr_ads
          }

          start_time = start_time.add(1, 'day')
          data.push(row)
        }

        this.data = data
        this.m__generate_scrollbar()
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.generate_data = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/agency/result.vue